module.exports = __webpack_public_path__ + "img/1377498224.67329058.jpg";